/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_PageInputs */

const ja_company_meta_page = /** @type {(inputs: Company_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`company`)
};

const en_company_meta_page = /** @type {(inputs: Company_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`company`)
};

/**
* | output |
* | --- |
* | "company" |
*
* @param {Company_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const company_meta_page = /** @type {((inputs?: Company_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_page(inputs)
	return en_company_meta_page(inputs)
});